import React, { createContext, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ModalFeedBack from '../ui-kit/modal-feed-back/modal-feed-back'

const ContactModalContext = createContext({
  openContactModal: () => {},
  closeContactModal: () => {},
})

export const ContactModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()

  const openContactModal = () => setIsOpen(true)
  const closeContactModal = () => setIsOpen(false)

  return (
    <ContactModalContext.Provider value={{ openContactModal, closeContactModal }}>
      {children}
      {isOpen && (
        <ModalFeedBack
          title={t('contactUs')}
          text={t('helpYou')}
          onClose={closeContactModal}
          url="support"
        />
      )}
    </ContactModalContext.Provider>
  )
}

export const useContactModal = () => useContext(ContactModalContext)